/* FELRIO — Product card image slider
   Mobile (<=1024px): swipe slider + dots (first card autoplays once as a hint).
   Desktop (>1024px): Zara-style — thin arrows fade in on card hover, slider
   is built lazily on first hover so big grids stay fast.
   Slides come from data-slides="url::alt|url::alt".
   Colour-pinned cards (data-felrio-color) only slide through that colour's
   images — same alt-text convention as the PDP gallery filter. */
(function () {
  "use strict";

  var BREAKPOINT = 1024;

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn, { once: true });
  }

  function isDesktop() {
    return window.innerWidth > BREAKPOINT;
  }

  /* Parse + filter slides for one card */
  function parseSlides(media) {
    var raw = media.dataset.slides || "";
    if (!raw) return [];

    var out = [];
    raw.split("|").forEach(function (entry) {
      if (!entry) return;
      var i = entry.indexOf("::");
      var url = i === -1 ? entry : entry.slice(0, i);
      var alt = i === -1 ? "" : entry.slice(i + 2);
      if (!url) return;
      if (alt.toLowerCase().indexOf("mock") !== -1) return; /* skip mockup shots */
      out.push({ url: url, alt: alt });
    });

    /* Colour-pinned card: keep only this colour's images */
    var color = (media.dataset.felrioColor || "").toLowerCase().trim();
    if (color) {
      var colorFiltered = out.filter(function (s) {
        return s.alt.toLowerCase().indexOf(color) !== -1;
      });
      /* Only narrow to colour if alt-text naming is set up — otherwise show all slides */
      if (colorFiltered.length >= 2) out = colorFiltered;
    }

    /* Rotate so the currently visible image is slide 1 (seamless takeover) */
    var img = media.querySelector("img");
    var src = img && (img.currentSrc || img.src);
    if (src && out.length > 1) {
      try {
        var path = new URL(src, location.href).pathname;
        for (var j = 0; j < out.length; j++) {
          if (new URL(out[j].url, location.href).pathname === path) {
            out = out.slice(j).concat(out.slice(0, j));
            break;
          }
        }
      } catch (e) { /* noop */ }
    }
    return out;
  }

  function eligible(media) {
    if (media.dataset.felrioSlider) return false; /* built or skipped */
    if (media.dataset.hasVideo === "true") return false; /* keep theme video hover */
    if (media.closest(".cart-drawer") || media.closest("quick-cart-drawer")) return false;
    return true;
  }

  function buildSwiperEl(media, slides, controls) {
    var refImg = media.querySelector("img");
    var wrapper = document.createElement("div");
    wrapper.className = "swiper-wrapper";

    slides.forEach(function (s, i) {
      var img = document.createElement("img");
      img.src = s.url;
      img.loading = i === 0 ? "eager" : "lazy";
      img.decoding = "async";
      img.alt = s.alt || (refImg && refImg.alt) || "";
      if (refImg) {
        if (refImg.width) img.width = refImg.width;
        if (refImg.height) img.height = refImg.height;
      }
      var slide = document.createElement("div");
      slide.className = "swiper-slide";
      slide.appendChild(img);
      wrapper.appendChild(slide);
    });

    var el = document.createElement("div");
    el.className = "swiper felrio-card-swiper";
    el.appendChild(wrapper);

    if (controls.dots) {
      var pag = document.createElement("div");
      pag.className = "swiper-pagination";
      el.appendChild(pag);
    }
    if (controls.arrows) {
      var prev = document.createElement("div");
      prev.className = "swiper-button-prev";
      var next = document.createElement("div");
      next.className = "swiper-button-next";
      el.appendChild(prev);
      el.appendChild(next);
    }
    return el;
  }

  function initCard(media, controls, optionsFor) {
    if (typeof Swiper === "undefined") return;
    var slides = parseSlides(media);
    if (slides.length < 2) {
      media.dataset.felrioSlider = "skip";
      return;
    }
    media.dataset.felrioSlider = "1";
    media.classList.add("felrio-armed");
    media.style.position = "relative";

    var el = buildSwiperEl(media, slides, controls);
    media.appendChild(el);
    new Swiper(el, optionsFor(el));
  }

  var firstMobileDone = false;

  function initMobile(media) {
    initCard(media, { dots: true, arrows: false }, function (el) {
      var opts = {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        threshold: 10,
        grabCursor: true,
        a11y: false,
        navigation: false,
        pagination: {
          el: el.querySelector(".swiper-pagination"),
          clickable: true
        }
      };
      if (!firstMobileDone) {
        firstMobileDone = true;
        opts.autoplay = {
          delay: 2000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        };
      }
      return opts;
    });
  }

  function armDesktop(media) {
    if (media.dataset.felrioArmed) return;
    media.dataset.felrioArmed = "1";
    var card = media.closest(".product-card") || media;
    card.addEventListener("mouseenter", function onEnter() {
      card.removeEventListener("mouseenter", onEnter);
      if (!eligible(media)) return;
      var inModelMode = document.body.getAttribute("data-felrio-model") === "1";
      initCard(media, { dots: false, arrows: true }, function (el) {
        return {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: true,
          initialSlide: inModelMode ? 0 : 1,
          threshold: 6,
          a11y: false,
          pagination: false,
          navigation: {
            nextEl: el.querySelector(".swiper-button-next"),
            prevEl: el.querySelector(".swiper-button-prev")
          }
        };
      });
      card.addEventListener("mouseenter", function () {
        var swiperEl = media.querySelector(".felrio-card-swiper");
        if (!swiperEl || !swiperEl.swiper) return;
        var modelMode = document.body.getAttribute("data-felrio-model") === "1";
        // Restore Swiper visibility (was hidden in MODEL mode on leave)
        swiperEl.style.opacity = "";
        swiperEl.style.pointerEvents = "";
        // MODEL mode → show first model image; normal → show 2nd model image
        swiperEl.swiper.slideToLoop(modelMode ? 0 : 1, 0);
      });
      card.addEventListener("mouseleave", function () {
        var swiperEl = media.querySelector(".felrio-card-swiper");
        if (!swiperEl || !swiperEl.swiper) return;
        if (document.body.getAttribute("data-felrio-model") === "1") {
          // Hide Swiper so the felrio-mock-img beneath it shows through
          swiperEl.style.opacity = "0";
          swiperEl.style.pointerEvents = "none";
        } else {
          swiperEl.swiper.slideToLoop(0, 0);
        }
      });
    });
  }

  function initAll() {
    var medias = document.querySelectorAll(".product-card__media[data-slides]");
    medias.forEach(function (media) {
      if (!eligible(media)) return;
      if (isDesktop()) armDesktop(media);
      else initMobile(media);
    });
  }

  window.felrioReinitSliders = initAll;

  var debounceTimer = null;
  function debouncedInit() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(initAll, 200);
  }

  function boot() {
    initAll();
    /* Re-init when the grid changes: filters, infinite scroll, load more */
    var target =
      document.getElementById("product-grid") ||
      document.querySelector(".js-collection-grid") ||
      document.body;
    if (window.MutationObserver) {
      new MutationObserver(debouncedInit).observe(target, {
        childList: true,
        subtree: true
      });
    }
    window.addEventListener("resize", debouncedInit);
  }

  ready(function () {
    var attempts = 0;
    var timer = setInterval(function () {
      attempts++;
      if (typeof Swiper !== "undefined" || attempts > 40) {
        clearInterval(timer);
        boot();
      }
    }, 100);
  });
})();
